import { createContext, useContext } from 'react';

import { CATALOGO_DE_HISTORIAS } from './catalogo';

/**
 * O ESTADO do modo histórias (manual p.48): "Começa desligado. Ligado,
 * continua ligado ao trocar de tela. Cada pessoa tem o próprio estado; ligar
 * não muda nada para os outros." Por isso o interruptor mora no aparelho
 * (`localStorage`), e só a conferência e a divergência vão ao servidor.
 *
 * "Só existe em homologação": o servidor diz se o ambiente é (0080). Fora
 * dele, o modo nunca liga, mesmo que o aparelho guarde "ligado".
 */
export interface ConferenciaDaHistoria {
  readonly codigo: string;
  readonly situacao: 'conferida' | 'divergente';
  readonly nota: string | null;
  readonly em: string;
  readonly quem: string | null;
}

export interface ValorDoModo {
  readonly homologacao: boolean;
  /** Ligado E em homologação: é o que a tela consulta para desenhar os marcadores. */
  readonly ativo: boolean;
  readonly ligadoNoAparelho: boolean;
  readonly alternar: () => void;
  readonly conferencias: ReadonlyMap<string, ConferenciaDaHistoria>;
  readonly naTela: readonly string[];
  readonly registrar: (codigo: string) => () => void;
  readonly aberta: string | null;
  readonly abrir: (codigo: string) => void;
  readonly fechar: () => void;
  /** A divergência pode ir a um perfil ("Enviar para", p.48, 0082); devolve o nome dele. */
  readonly conferir: (codigo: string, situacao: 'conferida' | 'divergente', nota?: string, paraPapelId?: string) => Promise<string | null>;
  readonly conferindo: boolean;
}

export const Contexto = createContext<ValorDoModo | null>(null);

const DESLIGADO: ValorDoModo = {
  homologacao: false, ativo: false, ligadoNoAparelho: false, alternar: () => undefined, conferencias: new Map(), naTela: [],
  registrar: () => () => undefined, aberta: null, abrir: () => undefined, fechar: () => undefined,
  conferir: async () => null, conferindo: false,
};

/** Fora do provedor (um teste, uma tela solta), o modo está desligado. */
export function useModoHistorias(): ValorDoModo {
  return useContext(Contexto) ?? DESLIGADO;
}

/** "3 de 9 conferidas": das histórias desta tela, as que o QA marcou. */
export function contagemDaTela(naTela: readonly string[], conferencias: ReadonlyMap<string, ConferenciaDaHistoria>): { total: number; conferidas: number } {
  const comHistoria = naTela.filter((c) => CATALOGO_DE_HISTORIAS.has(c));
  return { total: naTela.length, conferidas: comHistoria.filter((c) => conferencias.get(c)?.situacao === 'conferida').length };
}
